import safeFetch, { IFetchResponse } from 'lib/requests/fetch';
import { IImpersonatedUser } from './types';

export const endImpersonation = (): Promise<IFetchResponse<void>> => {
  return safeFetch<void>('/end-impersonation', {
    method: 'POST',
  });
};

export const getImpersonatedUser = (): Promise<
  IFetchResponse<IImpersonatedUser>
> => {
  return safeFetch<IImpersonatedUser>(
    '/impersonated-user',
    {},
    {
      dontRedirect: true,
    }
  );
};

export const startImpersonation = (
  userId: number
): Promise<IFetchResponse<void>> => {
  return safeFetch<void>('/start-impersonation', {
    method: 'POST',
    body: JSON.stringify({ userId }),
  });
};
